import styled from 'styled-components';
import { DatePickerMixin } from '../../mixins/components/DatePickerMixin';
export var StyledDatePicker = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledDatePicker",
  componentId: "c11n-8-111-1__sc-5rr0yu-0"
})(["", ""], DatePickerMixin);